<template>
    <div>
        <public-menu></public-menu>
        <public-help-dinggouliucheng></public-help-dinggouliucheng>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Public_help_dinggouliucheng from "@/components/help/dinggouliucheng"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default {
    components:{
        'public-menu': Public_menu,
        'public-help-dinggouliucheng': Public_help_dinggouliucheng,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');

</style>


// WEBPACK FOOTER //
// src/views/help/dinggouliucheng.vue